import { render, staticRenderFns } from "./ChildrenStatisticView.vue?vue&type=template&id=17b193ed&scoped=true&"
import script from "./ChildrenStatisticView.vue?vue&type=script&lang=js&"
export * from "./ChildrenStatisticView.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenStatisticView.vue?vue&type=style&index=0&id=17b193ed&prod&lang=scss&scoped=true&"
import style1 from "./ChildrenStatisticView.vue?vue&type=style&index=1&id=17b193ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b193ed",
  null
  
)

export default component.exports